module.exports = __webpack_public_path__ + "static/media/subject.44df4d05.svg";